import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./app/layout";
import SectionProducts from "./app/home/SectionProducts";
import CartPage from "./app/cart/page";
import SingleProductPage from "./app/products/[productId]/page";
import CheckoutPage from "./app/checkout/page";
import FailurePage from "./app/failure/page";
import SuccessPage from "./app/success/page";
import OrderCanceled from "./app/cancel/page";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<SectionProducts />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/products/:slug" element={<SingleProductPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/failure" element={<FailurePage />} />
          <Route path="/cancel" element={<OrderCanceled />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  </React.StrictMode>,
);
